import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    isEqual as _isEqual,
    cloneDeep as _cloneDeep
} from 'lodash';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import Auth from '../../../data/auth-service';
import DataContext from '../../../data/data-context';

const Eswd = () => {
    const navigate = useNavigate();
    const { systemSettings, updateSystemSettings } = useContext(DataContext);
    const [eswd, setEswd] = useState({
        es_ingest_none: false,
        es_ingest_conn_only: false,
    });
    const [original, setOriginal] = useState({});
    const [changes, setChanges] = useState(false);
    const eswdPerms = Auth.permissions.get('MetadataIngest');

    useEffect(() => {
        if (systemSettings && systemSettings.eswd) {
            const v = _cloneDeep(systemSettings.eswd);
            setEswd(v);
            setOriginal(systemSettings.eswd);
        }
    }, [systemSettings]);

    useEffect(() => {
        setChanges(_isEqual(eswd, original));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eswd]);

    const handleESNone = (e) => {
        // conn only if ingesting
        if (e.target.checked) {
            eswd.es_ingest_conn_only = false;
        }
        setEswd({
            ...eswd,
            es_ingest_none: e.target.checked,
        });
    };

    const handleESConn = (e) => {
        setEswd({
            ...eswd,
            es_ingest_conn_only: e.target.checked,
        });
    };

    const handleSave = () => {
        updateSystemSettings({ eswd });
    };

    const handleCancel = () => {
        navigate('/system/configuration');
    };

    return (
        <Grid container>
            <Grid item lg={6}>
                <Paper elevation={3}>
                    <Box p={5}>
                        <Typography variant="h5">Opensearch Metadata Ingestion</Typography>
                        <Box mt={2}>
                            <FormControlLabel
                                disabled={!eswdPerms.write}
                                label="Block ingestion of ANY Zeek metadata into CMC/Datanodes."
                                aria-label="no ingestion"
                                control={<Checkbox checked={eswd.es_ingest_none} onClick={handleESNone} />}
                            />
                            <FormControlLabel
                                disabled={!eswdPerms.admin || eswd.es_ingest_none}
                                label="Ingestion of only Zeek conn metadata into CMC/Datanodes."
                                aria-label="ingest conn only"
                                control={<Checkbox checked={eswd.es_ingest_conn_only} onClick={handleESConn} />}
                            />
                            <FormHelperText>
                                These settings do not affect metadata export jobs on CMCs, Datanodes, or Sensors.
                                However, metadata that is not ingested will not be available for viewing or searching in the interface.
                                Changes take effect immediately.
                            </FormHelperText>
                        </Box>
                        <Box mt={2} display="flex" justifyContent="flex-end">
                            {eswdPerms.write && <Box mr={2}><Button
                                variant="contained"
                                color="secondary"
                                aria-label="cancel"
                                onClick={handleCancel}
                            >Cancel</Button></Box>}
                            {(eswdPerms.write || eswdPerms.admin) && <Button
                                variant="contained"
                                color="primary"
                                aria-label="save"
                                onClick={handleSave}
                                disabled={changes}
                            >Save</Button>}
                        </Box>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default Eswd;
